import { Routes } from './routes';

export const navigationItems = [
  { title: 'shop', location: Routes.Shop, displayTitle: 'Products' },
  { title: 'signup', location: Routes.SignUp, displayTitle: 'Sign Up' },
  { title: 'sizing', location: Routes.Sizing, displayTitle: 'Size Guide' },
  {
    title: 'sustainability',
    location: Routes.Sustainability,
    displayTitle: 'Sustainability',
  },
  {
    title: 'foundation',
    location: Routes.Foundation,
    displayTitle: 'Foundation',
  },
  { title: 'terms', location: Routes.Terms, displayTitle: 'Terms' },
  {
    title: 'privacy',
    location: Routes.Privacy,
    displayTitle: 'Privacy policy',
  },
  { title: 'cookie', location: Routes.Cookie, displayTitle: 'Cookie policy' },
  // {
  //   title: 'shipping-prices',
  //   location: Routes.ShippingPrices,
  //   displayTitle: 'Shipping Prices',
  // },
];

export default navigationItems;
